import {
  Button,
  Dropdown,
  DropdownMenu,
  type DropdownMenuItem,
  QuestionmarkCircleIcon,
} from "@bp/ui-components";
import type { SearchData } from "../../utils/globalSearch";
import { AgentMenu } from "../AgentMenu/AgentMenu";
import { CommandSearch } from "../CommandSearch/CommandSearch";
import styles from "./AppHeader.module.scss";

type AppHeaderProps = {
  data: SearchData;
};

/**
 * App header, modelled 1:1 on planung-frontend's AppHeader: a gutter-aligned bar
 * (same `padding-left` calc that reserves the fixed sidebar) with a centered,
 * max-width `.container` laid out `space-between`. Left = the global ⌘K
 * CommandSearch (in place of planung's school-year select); right = a help
 * dropdown + the account menu. (No burger, no audit-log button.)
 */
export function AppHeader({ data }: AppHeaderProps) {
  const helpEntries: DropdownMenuItem[] = [
    {
      label: "Was ist neu",
      onClick: () => window.open("https://r.tks.eu/changelog", "_blank", "noopener,noreferrer"),
    },
    {
      label: "Handbücher",
      onClick: () => window.open("https://r.tks.eu/doku", "_blank", "noopener,noreferrer"),
    },
  ];

  return (
    <header className={styles["app-header"]} data-cy="headerWrapper">
      <div className={styles.container}>
        <div className={styles.left}>
          <CommandSearch data={data} />
        </div>
        <div className={styles.right}>
          <Dropdown
            trigger={
              <Button hierarchy="tertiary" icon={<QuestionmarkCircleIcon />} ariaLabel="Hilfe" />
            }
          >
            <DropdownMenu data={helpEntries} />
          </Dropdown>
          <AgentMenu />
        </div>
      </div>
    </header>
  );
}
